import { translate } from '@jsverse/transloco';

import { Dashboard } from 'app/providers/bridge-api/dashboard.service';
import { AnalysisGroup } from 'app/providers/storage-api/analysis-group-service';
import { Analysis } from 'app/providers/storage-api/analysis.service';
import { Project } from 'app/providers/storage-api/project.service';
import { ObjectLabel, ItemLabel } from '../../../providers/storage-api/object-label.service';
import { DisplayItem, ProjectItem } from '../services/project-detail.service';
import { mapObjectLabelsToProjectItemLabels } from './common.model';

export class ProjectDashboard {
  static createDashboardItem(dashboard: Dashboard, project: Project): ProjectItem {
    const dataSources = this.getDashboardDatasources(dashboard, project);
    const displayData: DisplayItem = {
      analysisDataSources: dataSources[0] as Analysis[],
      groupDataSources: dataSources[1] as AnalysisGroup[],
      isLocked: dashboard.locked,
    };

    return {
      type: 'dashboard',
      id: dashboard.id,
      name: dashboard.title,
      modified: new Date(dashboard.user_modified_at_date),
      created: new Date(dashboard.created_at_date),
      labels: this.createDashboardLabels(dashboard),
      displayData,
      dashboard,
    };
  }

  static createDashboardLabels(dashboard: Dashboard): Partial<ItemLabel>[] {
    const labels = [];

    if (dashboard.payload.isExecutive) {
      labels.push({
        label: 'EV',
        tooltip: translate('project-dashboard-model.executive-view'),
        type: 'system',
      });
    }

    if (dashboard.payload.type === 'predictive') {
      labels.push({
        label: 'IP',
        tooltip: translate('project-dashboard-model.impact-predictor-dashboard'),
        type: 'system',
      });
    }

    if (dashboard.visibility === 'UNLISTED') {
      labels.push({
        label: 'H',
        tooltip: translate('project-dashboard-model.hidden'),
        type: 'system',
      });
    }

    labels.push(...mapObjectLabelsToProjectItemLabels(dashboard.objectLabels as ObjectLabel[]));

    return labels;
  }

  static getDashboardDatasources(dashboard: Dashboard, project: Project) {
    const analysisSources = new Set<Analysis>();
    const groupSources = new Set<AnalysisGroup>();
    for (const widget of dashboard.widgets) {
      const foundAnalysisIndex = project.analyses.findIndex((a) => a.name === widget.dataSourceId);
      if (foundAnalysisIndex !== -1) {
        analysisSources.add(project.analyses[foundAnalysisIndex]);
      }
      const foundGroupIndex = project.groups.findIndex((g) => g.id === widget.dataSourceId);
      if (foundGroupIndex !== -1) {
        groupSources.add(project.groups[foundGroupIndex]);
      }
    }
    return [[...analysisSources], [...groupSources]];
  }
}
